module.exports = __webpack_public_path__ + "static/img/page-title-1.722464a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page-title-1.png
// module id = zX4R
// module chunks = 156